import { render, staticRenderFns } from "./AssessmentCentreUpdates.vue?vue&type=template&id=26647d01&scoped=true"
import script from "./AssessmentCentreUpdates.vue?vue&type=script&lang=js"
export * from "./AssessmentCentreUpdates.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCentreUpdates.vue?vue&type=style&index=0&id=26647d01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26647d01",
  null
  
)

export default component.exports